var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBoxWithLid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_667_883)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08337 2.75V3.91667H13.9167V2.75H2.08337ZM0.583374 2.66667C0.583374 1.88445 1.21783 1.25 2.00004 1.25H14C14.7823 1.25 15.4167 1.88445 15.4167 2.66667V4C15.4167 4.78221 14.7823 5.41667 14 5.41667H2.00004C1.21783 5.41667 0.583374 4.78221 0.583374 4V2.66667Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 7.33333C5.25 6.91911 5.58579 6.58333 6 6.58333H10C10.4142 6.58333 10.75 6.91911 10.75 7.33333C10.75 7.74754 10.4142 8.08333 10 8.08333H6C5.58579 8.08333 5.25 7.74754 5.25 7.33333Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22205 3.91667C2.63626 3.91667 2.97205 4.25246 2.97205 4.66667V12.6667C2.97205 12.9891 3.23293 13.25 3.55538 13.25H12.4447C12.7672 13.25 13.028 12.9891 13.028 12.6667V4.66667C13.028 4.25246 13.3638 3.91667 13.778 3.91667C14.1923 3.91667 14.528 4.25246 14.528 4.66667V12.6667C14.528 13.8176 13.5956 14.75 12.4447 14.75H3.55538C2.4045 14.75 1.47205 13.8176 1.47205 12.6667V4.66667C1.47205 4.25246 1.80783 3.91667 2.22205 3.91667Z",
    className: "icon-fill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_667_883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxWithLid);
export default __webpack_public_path__ + "static/media/icon-box-with-lid.84d87e3d19e89dc246e71ed3efbe7f94.svg";
export { ForwardRef as ReactComponent };